<template>
  <div class="goods_item" @mousemove.stop=""  @click.stop="godetail">
    <s-image class="top_image" :src="item.goods_images[0]" mode="aspectFill" borderRadius=".5rem .5rem 0 0" />
    <div class="goods_info">
      <div class="goods_name sizeomit2">{{item.goods_name}}</div>
      <div class="goods_price">
        <div class="price"><span>￥</span>{{item.price&&item.price[0]}}</div>
        <div class="shou_num">已售{{formatNumber(item.sell_num)}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UniMailiangGoodsItem',
  props: ['item'],
  data() {
    return {

    };
  },

  mounted() {

  },

  methods: {
    godetail() {
      this.$router.push({
        path: '/pages/shop/goodsDetail',
        query: { id: this.item.id }
      })
    },
    formatNumber(num) {
      if(num< 100) return num
      if (num < 10000) {
        return Math.floor(num / 100) * 100 + '+';
      } else {
        return ((num / 10000).toFixed(1) + 'w+');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.goods_item {
  width: 100%;
  background: #ffffff;
  border-radius: .5rem;
  display: inline-block;
  .top_image {
    width: 100%;
    height: 8.6rem;
    aspect-ratio: 1/1;
    overflow: hidden;
  }
  .goods_info {
    padding: .45rem;
    font-size: .7rem;
    // height: 3.15rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-bottom: .65rem;
    .goods_name{
      line-height: 1rem;
      margin-bottom: .5rem;
    }
    .goods_price {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .price {
        color: #ffad0d;
        font-weight: 700;
        span {
          font-size: .5rem;
          font-weight: normal;
        }
      }
      .shou_num{
        font-size: .6rem;
        color: #8E8E8E;
      }
    }
  }
}
</style>